<template>

</template>

<script>
    /*
    * 该页面作为项目入口，用来判断用户的来源
    * */

    export default {
        name: "Source",
        created() {
            /*
            * 不管商家还是代理进入本H5，必须先进入该页面
            * 商家用户进入，必带source参数值为store
            * 代理用户进入，不比带source参数，如果带参数不可带值为store
            * */
            let {source} = this.$route.query;
            this.$store.commit('SET_IS_STORE', source === 'store');
            // 获取用户信息
            this.$store.dispatch('getUserInfo').then(result => {
                if (result) {
                    this.toPage('/mine', true)
                }
            })
        }
    }
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/page/Source.vue